/**
 * Created by Astha on 11/12/2019.
 */
import React from "react";
import { ThemeSetup } from "../../../themes/ThemeSetup";
import "./Info.css";

type State = {
  show: boolean,
  hoverIcon: boolean
}
type Props = {
  text: string,
  uuid: number
}
export default class Info extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      top: -57,
    }
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.setShowState, false);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.setShowState, false);
  }

  setShowState = (event) => {
    const {uuid} = this.props;
    const path = event.path || (event.composedPath && event.composedPath());
    if (!path.includes(this.refs[uuid]) &&  event.target !== this._icon) {
      this.setState({
        show: false
      });
    }
  };
  setHeight = (eventX, eventY) => {
    const uuid = this.props.uuid;
    const el = this.refs[uuid];
    let height;
    if (el) {
      height = el.clientHeight;
    }
    const top = -height;
    this.setState({top})
  };

  renderInfo() {
    const {text, uuid} = this.props;
    return (
      <div name="Tooltip">
        <div className="bg" style={{top: this.state.top}} ref={uuid}>
          <div className="content">{this.props.children}</div>
        </div>
      </div>
    )
  }

  onShowingTooltip = (eventX, eventY) => {
    if (this.state.show) {
      this.setHeight(eventX, eventY);
    }
  };
  onImageClick = (event) => {
    const {clientX, clientY} = event;
    this.setState({
        show: !this.state.show,
      }, () => this.onShowingTooltip(clientX, clientY)
    );
  };


  showIcon = () => {
    const {show} = this.state;
    return (
      <div  onClick={(event) => this.onImageClick(event)}>
        {show ? <img ref ={(node) => this._icon = node } data-toggle="tooltip" src={ThemeSetup.getImageURL('ques_mark.svg')} /> :
          <img ref ={(node) => this._icon = node } data-toggle="tooltip" src={ThemeSetup.getImageURL('grey_ques_mark.svg')} />}
      </div>
    )
  }

  render() {
    const {show} = this.state;
    return (
      <div name="Info" >
        {show ? this.renderInfo() : null}
        <div className="icon">
          {this.showIcon()}
        </div>
      </div>
    )
  }
}
